import { EReadyStatus } from '../../types/filters';

interface IReadyStatus {
  label: string;
  value: EReadyStatus;
}

export const READY_STATUSES: IReadyStatus[] = [
  { label: 'Строится', value: EReadyStatus.Building },
  { label: 'Построен', value: EReadyStatus.Built },
  { label: 'Заморожен', value: EReadyStatus.Frozen },
  { label: 'В проекте', value: EReadyStatus.Planning },
];
